import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Marathons/Create';

const { displayName } = config;

function MarathonCreate(): React.JSX.Element {
  document.title = `${displayName}: Добавить марафон`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default MarathonCreate;
